import { useState } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { Target } from 'lucide-react';
import { useEmployeeContext } from '@/shared/contexts/EmployeeContext';
import { CreateGoalModal } from '@/features/goals/goal-form/CreateGoalModal';
import { GoalsTreeView } from '@/features/goals/hierarchy-tree/GoalsTreeView';
import { GoalsFilters } from '@/features/goals/components/GoalsFilters';
import { PlatformRestriction } from '@/shared/navigation/components/PlatformRestriction';
import { CreateTaskModal } from '@/features/goals/goal-form/CreateTaskModal';
import { IntegrationsDialog } from '@/features/goals/integrations/IntegrationsDialog';
import { PageHeader } from '@/shared/components/PageHeader';

export const Route = createFileRoute('/_dashboard/goals')({
  component: () => (
    <PlatformRestriction notAllowedPlatforms={['mobile']}>
      <RouteComponent />
    </PlatformRestriction>
  ),
});

function RouteComponent() {
  const { t } = useTranslation('goals');
  const employee = useEmployeeContext();
  const [selectedEmployee, setSelectedEmployee] = useState<string | undefined>(
    employee._id
  );
  const [showCompleted, setShowCompleted] = useState<boolean>(true);
  const [expandedNodes, setExpandedNodes] = useState<Set<string>>(new Set());
  const handleCollapseAll = () => {
    setExpandedNodes(new Set());
  };

  return (
    <div className="min-h-screen">
      <PageHeader title={t('pageTitle')} icon={Target}>
        <GoalsFilters
          selectedEmployeeId={selectedEmployee}
          onEmployeeChange={setSelectedEmployee}
          showCompleted={showCompleted}
          onShowCompletedChange={setShowCompleted}
          onCollapseAll={handleCollapseAll}
        />
        <IntegrationsDialog />
        <CreateGoalModal />
        <CreateTaskModal />
      </PageHeader>

      <div className="mx-4 py-6 sm:mx-6 lg:mx-8">
        <div className="mx-auto max-w-7xl">
          <GoalsTreeView
            selectedEmployeeId={selectedEmployee}
            showCompleted={showCompleted}
            expandedNodes={expandedNodes}
            setExpandedNodes={setExpandedNodes}
          />
        </div>
      </div>
    </div>
  );
}
